import { Theme } from "@mui/material";

const MuiTabs = (theme: Theme) => ({
  defaultProps: {
    indicatorColor: "secondary",
  },
});
export default MuiTabs;
